import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-data-statistics",
  "use": "icon-data-statistics-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-data-statistics\"><defs><style type=\"text/css\"></style></defs><path d=\"M864.664 357.198l-75.709-75.637L669.853 391.52v404.062h222.262V254.898l-27.452 102.301zM468.103 496.82l-68.132-43.892v342.653h222.266V435.482l-57.332 52.835c-14.586 13.58-33.887 21.084-53.761 21.084-15.3 0-30.028-4.356-43.042-12.581z m-115.739-74.489l-56.194-36.173-166.075 144.48v264.944h222.27V422.331z m-222.27 428.372h762.022v79.357H130.094v-79.357z m52.693-420.581l109.095-95.441 202.031 130.042c5.29 3.288 11.226 5.005 17.231 5.005 7.72 0 15.441-2.86 21.518-8.436l257.655-237.919 49.685 49.685 48.111-179.514-179.514 48.111 36.818 36.817L507.64 397.953 306.036 268.338c-11.937-7.507-27.452-6.505-38.103 2.86l-127.04 111.098c-13.085 11.578-14.512 31.598-2.932 44.826 11.51 13.223 31.598 14.51 44.826 3z\" p-id=\"14875\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/data-statistics.svg
// module id = HoT7
// module chunks = 68